var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{directives:[{name:"testid",rawName:"v-testid",value:('dp-loading'),expression:"'dp-loading'"}],attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"6","offset":"3"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":_vm.loadingImage,"alt":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }